/**
* @Author: zachalam
* @Date:   2017-03-19T19:04:40-07:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-03-19T19:04:40-07:00
*/


import React, { Component } from 'react';
import Report from '../components/pages/Settings/Report';
import { connect } from 'react-redux';
import { refreshExternalProfile, reportUser } from '../actions/profileActions';

class ReportContainer extends Component {

  componentWillMount() {
    this.props.refreshExternal(this.props.params.username);
  }

  render() {
    return (
      <Report {...this.props} />
    );
  }
}


const mapStateToProps = (state) => {
  return {
    extprofile: state.extprofile
  }
}

const mapDispatchToProps = (dispatch,ownProps) => {
  return {
    refreshExternal(username) {
      return dispatch(refreshExternalProfile(username));
    },
    submit: (formData) => {
      dispatch(reportUser(formData));
    }
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(ReportContainer);



// WEBPACK FOOTER //
// ./src/containers/ReportContainer.jsx